<div class="clock">
    <div class="clock__container">
        <span class="clock__date">{{ (time$ | async)?.dateFormatted }}</span>
        <span class="clock__time">{{ (time$ | async)?.timeFormatted }} <span class="clock__timezone">UTC</span></span>
    </div>
</div>